import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DefaultNav from './DefaultNav/index.jsx';
import MobileNav from './MobileNav/index.jsx';
import styles from './style.module.scss';

const routes = [
  {to: '/', title: 'Home'},
  {to: '/process', title: 'Process'},
  {to: '/lookbook', title: 'Lookbook'},
  {to: '/campus-managers', title: 'Campus Managers'},
];

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }

  render() {
    const { children } = this.props;
    const { width } = this.state;

    return (
      <div>
        <header>
          <div className={styles.container}>
            { width > 1024 ? <DefaultNav routes={routes}/>:<MobileNav routes={routes}/> }
          </div>
        </header>
        <div className={styles.bodyContainer}>
          {children}
        </div>
      </div>
    );
  }
}

Navigation.propTypes = {
  children: PropTypes.func,
};

export default Navigation;